<div fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="start center">
    <form
      [formGroup]="searchForm"
      fxLayout="row"
      fxLayoutAlign="start center"
      class="width-100 form-design"
    >
      <fa-icon class="icon-design" [icon]="icon" size="lg" [fixedWidth]="true"></fa-icon>
      <input
        placeholder="{{ label | translate }}"
        formControlName="query"
        class="width-100 input-design"
      />
    </form>
  </div>
  <span [style.visibility]="showWarning ? 'visible' : 'hidden'" class="search-warning">
    {{ 'SHARED_COMPONENTS.SEARCH.MIN_LENGTH' | translate }}
  </span>
</div>
